var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerI(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 40,
    viewBox: "0 0 7 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4C4.60457 4 5.5 3.10457 5.5 2C5.5 0.89543 4.60457 0 3.5 0C2.39543 0 1.5 0.89543 1.5 2C1.5 3.10457 2.39543 4 3.5 4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 10.2199L2.5 8L4.5 8L4.5 10.2199L2.5 10.2199ZM2.5 18.2199L2.5 13.7801L4.5 13.7801L4.5 18.2199L2.5 18.2199ZM2.5 26.2199L2.5 21.7801L4.5 21.7801L4.5 26.2199L2.5 26.2199ZM2.5 34.2199L2.5 29.7801L4.5 29.7801L4.5 34.2199L2.5 34.2199ZM2.5 40L2.5 37.7801L4.5 37.7801L4.5 40L2.5 40Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerI);
export default __webpack_public_path__ + "static/media/LOWER_I.f7318d2d1f0a1eec33d8ec981636b0fc.svg";
export { ForwardRef as ReactComponent };